import { EDIT_NOTE } from 'constants/action_types'

export default function doEditNote(noteId, noteText) {
  return {
    type: EDIT_NOTE,
    data: { noteId, noteText },
  }
}
